// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__-qVE9","empty":"ModalGraph_empty__13YeY"};